import Alpine from "./Presentation/Universal";
import "./Presentation/Block/Newsletter";
import "./Presentation/Module/Slider";
import "./Presentation/Module/Filter";
import "Packages/Carbon/Carbon.Image/Resources/Private/Assets/Main";
import "DistributionPackages/Schuetz.Projects/Resources/Private/Fusion/Main";

document.addEventListener("prettyembed", (event) => {
    window.plausible("Video", { props: event.detail });
});

Alpine.start();
